// src/components/ConnectActions.tsx
//
// The two real, working actions for reaching Five Dollar Workday —
// shared between AgentCard.tsx and LandingView.tsx's hero/closing CTA,
// so both stay in sync. "Sign up" always works (creates a real entity).
// "Copy MCP URL" always works (the real, live-tested, entity-scoped
// endpoint). Neither button needs to know about Journey A/C state —
// the actual "not yet accepting new merchants" boundary is enforced
// downstream, at record_outcome/install_starter_kit, not here.
//
// UPDATED — converted from raw <button> to the shared shadcn Button
// component (ui/button.tsx), so rounding, colour, and sizing are
// centrally controlled via buttonVariants/--radius/--color-brand-accent
// instead of hardcoded here.

import React, { useState } from 'react';
import { Button } from './ui/button';
import { Copy, Check } from 'lucide-react';

const FDW_UID = '3vuuC2kHE5ciUd1r3IKNVs7SEfp1';
const MCP_URL = `https://fivedollarworkday.com/mcp/e/${FDW_UID}`;

interface ConnectActionsProps {
  onSignUpClick?: () => void;
  layout?: 'stacked' | 'inline';
}

export const ConnectActions: React.FC<ConnectActionsProps> = ({ onSignUpClick, layout = 'inline' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyMcpUrl = async () => {
    try {
      await navigator.clipboard.writeText(MCP_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy MCP URL:', err);
    }
  };

  return (
    <div className={layout === 'inline' ? 'flex flex-row gap-3' : 'flex flex-col gap-2'}>
      <Button variant="primary" size="lg" onClick={onSignUpClick}>
        Sign up to FDW
      </Button>
      <Button variant="outline" size="lg" onClick={handleCopyMcpUrl} className="gap-2">
        {copied ? 'Copied!' : 'Connect via MCP'}
        {copied ? <Check className="size-3.5 text-green-600" /> : <Copy className="size-3.5" />}
      </Button>
    </div>
  );
};